/**
* 帖子管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welcome' }">表白墙信息管理</el-breadcrumb-item>
      <el-breadcrumb-item>帖子管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="学校：">
        <el-select v-model="formInline.schoolId" filterable clearable>
          <el-option label="全部" value=""/>
          <el-option v-for="item in schoolSelect" :key="item.id" :value="item.id" :label="item.name"/>
        </el-select>
      </el-form-item>
      <el-form-item label="帖子类型：">
        <el-select v-model="formInline.topic" filterable clearable>
          <el-option label="全部" value=""/>
          <el-option label="校 园 墙" value="1"/>
          <el-option label="二手闲置" value="2"/>
          <el-option label="打听求助" value="3"/>
          <el-option label="生活分享" value="4"/>
        </el-select>
      </el-form-item>
      <el-form-item label="帖子内容：">
        <el-input size="small" v-model="formInline.title" placeholder="请输入帖子内容" clearable/>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="formInline.isTop" true-label="1" false-label="0">置顶</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="postsData" highlight-current-row v-loading="loading"
              border element-loading-text="拼命加载中" style="width: 100%;">
      <!--      <el-table-column align="center" type="selection" width="50" :selectable="selectStatus"/>-->
      <el-table-column align="center" label="置顶" show-overflow-tooltip width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isTop? 'success' : 'warn'" disable-transitions>
            {{ scope.row.isTop ? "是" : "否" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="schoolName" label="学校" show-overflow-tooltip width="200"/>
      <el-table-column align="center" prop="authorName" label="用户" show-overflow-tooltip width="150"/>
      <el-table-column align="center" prop="isAnonymous" label="匿名" :formatter="anonymousFormatter"/>
      <el-table-column align="center" prop="topicName" label="帖子类型" width="120"/>
      <el-table-column align="center" prop="title" label="帖子内容" show-overflow-tooltip width="200"/>
      <el-table-column align="center" prop="price" label="二手闲置价格" width="120" :formatter="priceFormatter"/>
      <el-table-column align="center" label="帖子图片" width="150">
        <template slot-scope="scope">
          <el-carousel v-if="scope.row.pictureList != null && scope.row.pictureList.length>1" height="50px"
                       arrow="always" indicator-position="none" :autoplay="false" trigger="click">
            <el-carousel-item v-for="picture in scope.row.pictureList" :key="picture">
              <el-image style="width: 50px; height: 50px" :src="picture"
                        :preview-src-list="picturePreview(scope.row.pictureList)"/>
            </el-carousel-item>
          </el-carousel>
          <el-image v-else-if="scope.row.pictureList != null" style="width: 50px; height: 50px"
                    :src="scope.row.pictureList[0]" :preview-src-list="picturePreview(scope.row.pictureList)"
                    :initial-index="0" preview-teleported/>
        </template>
      </el-table-column>
      <el-table-column align="center" label="帖子视频" width="150">
        <template slot-scope="scope">
          <!--          <el-image v-if="scope.row.videoList != null" style="width: 50px; height: 50px; border: 1px solid red;" >
                      <div slot="error" class="image-slot" @click="openVideo">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>-->
          <video v-if="scope.row.videoList != null" :src="scope.row.videoList[0]" style="width: 50px; height: 50px;"
                 class="video" @click="openVideo(scope.row.videoList[0])"/>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="gmtCreate" label="创建时间" width="160"/>
      <!--      <el-table-column align="center" sortable prop="gmtUpdate" label="更新时间" width="150"/>-->
      <el-table-column align="center" sortable prop="pageViewNum" label="浏览" width="80"/>
      <el-table-column align="center" sortable prop="likeNum" label="点赞" width="80"/>
      <el-table-column align="center" sortable prop="repliesCount" label="评论" width="80"/>
      <el-table-column align="center" sortable prop="subscribeNum" label="订阅" width="80"/>
<!--      <el-table-column align="center" prop="urlLink" label="小程序短链接" width="200" show-overflow-tooltip/>-->
      <el-table-column align="right" label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" v-if="scope.row.isTop" @click="cancelTop(scope.$index, scope.row)">
            取消置顶
          </el-button>
          <el-button size="mini" type="success" v-if="!scope.row.isTop" @click="top(scope.$index, scope.row)">置顶
          </el-button>
          <el-button size="mini" type="danger" @click="remove(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
      <!--      <el-table-column v-if="user.userType==='admin'" align="center" label="酒店佣金">-->
      <!--        <el-table-column align="center" prop="hotelProportion" width="80" label="比例" :formatter="proportionFormatter"/>-->
      <!--        <el-table-column align="center" sortable prop="hotelPrice" width="80" label="金额" :formatter="moneyFormatter"/>-->
      <!--        <el-table-column align="center" sortable prop="hotelStatus" width="80" label="状态" show-overflow-tooltip :formatter="hotelStatusFormat"/>-->
      <!--        <el-table-column align="center" sortable prop="cashTime" label="操作时间" show-overflow-tooltip/>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column align="center" label="销售佣金">-->
      <!--        <el-table-column align="center" prop="proportion" width="80" label="比例" :formatter="proportionFormatter"/>-->
      <!--        <el-table-column align="center" sortable prop="price" width="80" label="金额" :formatter="moneyFormatter"/>-->
      <!--        <el-table-column align="center" sortable prop="status" width="80" label="状态" show-overflow-tooltip :formatter="statusFormat"/>-->
      <!--        <el-table-column align="center" sortable prop="extractTime" label="操作时间" show-overflow-tooltip/>-->
      <!--      </el-table-column>-->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageParam" @callFather="callFather"></Pagination>

    <!-- 视频播放界面 -->
    <el-dialog :visible.sync="dialogVisible" @close="closeVideo">
      <video :src="dialogVideo" controls autoplay class="video" width="100%" height="500px"/>
    </el-dialog>
  </div>
</template>

<script>
// 导入请求方法
import {postsList, deleteById, topById, cancelTopById} from '../../api/postsMG'
import {schoolList} from '../../api/schoolMG'
import Pagination from '../../components/Pagination'
// const value1 = ref('')
export default {
  data() {
    return {
      dialogVisible: false,
      dialogVideo: null,
      postsData: [],  //帖子数据
      schoolSelect: [], //学校下拉列表
      loading: false, //是显示加载
      // 请求数据参数
      formInline: {
        pageNum: 1,
        pageSize: 20,
        schoolId: '',
        topic: '',
        title: null,
        isTop: "0"
      },
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 分页参数
      pageParam: {
        currentPage: 1,
        pageSize: 20,
        total: 20
      },
      //角色列表
      roleList: []
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */
  watch: {},
  /**
   * 创建完毕
   */
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
    this.querySchoolList()
    this.getdata(this.formInline)
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //查询学校列表
    querySchoolList: function () {
      schoolList().then(res => {
        this.loading = false
        if (res.code == 0) {
          res.data.forEach(item => {
            this.schoolSelect.push(item);
          })
        } else {
          this.$message({type: 'info', message: res.msg})
        }
      }).catch(() => {
        this.$message({type: 'info', message: res.msg})
      })
    },
    // 获取数据方法
    getdata(parameter) {
      this.loading = true
      this.loading = false
      postsList(parameter).then(res => {
        this.loading = false
        if (res.code != 0) {
          this.$message({type: 'info', message: res.msg})
        } else {
          this.postsData = res.data.list
          // 分页赋值
          this.pageParam.currentPage = res.data.page
          this.pageParam.pageSize = res.data.limit
          this.pageParam.total = res.data.total
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //删除
    remove(index, row) {
      let id = row.id;
      this.$confirm('帖子删除无法回复，确认删除?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteById({id: id}).then(res => {
          if (res.code == 0) {
            this.$message({type: 'success', message: '删除成功!'})
            this.getdata(this.formInline)
          } else {
            this.$message({type: 'info', message: res.msg})
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('操作失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消此操作！'})
      })
    },
    //置顶
    top(index, row) {
      let id = row.id;
      this.$confirm('此操作会改变数据排序，确认操作?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        topById({id: id}).then(res => {
          if (res.code == 0) {
            this.$message({type: 'success', message: '置顶成功!'})
            this.getdata(this.formInline)
          } else {
            this.$message({type: 'info', message: res.msg})
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('操作失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消此操作！'})
      })
    },
    //取消置顶
    cancelTop(index, row) {
      let id = row.id;
      this.$confirm('此操作会改变数据排序，确认操作?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        cancelTopById({id: id}).then(res => {
          if (res.code == 0) {
            this.$message({type: 'success', message: '取消置顶成功!'})
            this.getdata(this.formInline)
          } else {
            this.$message({type: 'info', message: res.msg})
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('操作失败，请稍后再试！')
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消此操作！'})
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') {
        this.dataAccessshow = false
      } else if (dialog == 'unit') {
        this.unitAccessshow = false
      }
    },
    //图片预览大图
    picturePreview(pictureList) {
      return pictureList;
    },
    openVideo(videoUrl) {
      this.dialogVideo = videoUrl;
      this.dialogVisible = true;
    },
    closeVideo() {
      this.dialogVideo = '';
      this.dialogVisible = false;
    },
    //价格格式化
    priceFormatter: function (row) {
      if (row.price != null) {
        return row.price + "元"
      }
      return "-"
    },
    //是否匿名格式化
    anonymousFormatter: function (row) {
      return (row.isAnonymous ? "是" : "");
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

/deep/ .el-carousel__arrow {
  width: 15px;
  height: 15px;
  font-size: 15px;
}

/deep/ .el-carousel__button {
  width: 5px;
  height: 5px;
  border: none;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.2);
}

/deep/ .is-active .el-carousel__button {
/ / 指示器激活按钮 background: #3f8ec8;
}

/deep/ .el-carousel__container {
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/views/posts/posts.vue